import type { GroupProposal } from './group-proposal';

interface ChangeBadgeData {
  changeType: 'create' | 'addMembers' | 'removeMembers' | 'delete';
  text: string;
}

// Helper function to generate change badge data from a group proposal
export function getChangeBadges(proposal: GroupProposal): ChangeBadgeData[] {
  const badges: ChangeBadgeData[] = [];

  // CREATE action
  if (proposal.action === 'CREATE') {
    badges.push({
      changeType: 'create',
      text: 'Create group',
    });
    return badges;
  }

  // DELETE action
  if (proposal.action === 'DELETE') {
    badges.push({
      changeType: 'delete',
      text: 'Delete group',
    });
    return badges;
  }

  // UPDATE action - check what's being updated
  if (proposal.action === 'UPDATE') {
    // Member changes
    const addedMembers = proposal.groupMemberProposals.filter(
      (m) => m.action === 'ADD'
    );
    const removedMembers = proposal.groupMemberProposals.filter(
      (m) => m.action === 'REMOVE'
    );

    if (addedMembers.length > 0) {
      const count = addedMembers.length;
      badges.push({
        changeType: 'addMembers',
        text: `Add ${count} member${count > 1 ? 's' : ''}`,
      });
    }

    if (removedMembers.length > 0) {
      const count = removedMembers.length;
      badges.push({
        changeType: 'removeMembers',
        text: `Remove ${count} member${count > 1 ? 's' : ''}`,
      });
    }
  }

  return badges;
}
